import Competitions from './Views/Competitions';
import Contact from './Views/Contact';
import OfficePlant from './Views/OfficePlant';
import GameConsole from './Views/GameConsole';
import TrackerBot from './Views/TrackerBot';
import KitHub from './Views/KitHub';
import JumpingKit from './Views/JumpingKit';
import { LanguageProvider, useI18n } from './i18n/LanguageContext';
import { useEffect } from 'react';
import './App.css';
import Header from './compos/Header/Header';
import Footer from './compos/Header/Footer';
import Home from './Views/home';
import { Link, Route, Routes, useLocation } from 'react-router-dom';
import ProductsHome from './Views/ProductsHome';
import Downloads from './Views/Downloads';
import About from './Views/About';
import Services from './Views/Services';

function AppContent() {
  const { t } = useI18n();
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) document.getElementById(hash.slice(1))?.scrollIntoView();
    else window.scrollTo(0, 0);
  }, [pathname, hash]);
  return <div className="App"><a className="skipLink" href="#main">{t("Skip to content")}</a><Header/><main id="main" className="App-body"><Routes><Route path="/kits" element={<KitHub/>}/><Route path="/kits/office-plant" element={<OfficePlant/>}/><Route path="/kits/game-console" element={<GameConsole/>}/><Route path="/kits/tracker-bot" element={<TrackerBot/>}/><Route path="/kits/jumping-kit" element={<JumpingKit/>}/>
    <Route path="/competitions" element={<Competitions/>}/><Route path="/" element={<Home/>}/><Route path="/products" element={<ProductsHome/>}/><Route path="/downloads" element={<Downloads/>}/><Route path="/about" element={<About/>}/><Route path="/services" element={<Services/>}/><Route path="/contact" element={<Contact/>}/>
    <Route path="*" element={<section className="pageIntro shell"><p className="eyebrow">404</p><h1>{t("This page is still on the workbench.")}</h1><Link className="button primary" to="/">{t("Back to home")}</Link></section>}/>
  </Routes></main><Footer/></div>;
}
export default function App() { return <LanguageProvider><AppContent/></LanguageProvider>; }
